<template>
  <h2 class="text-n-900 dark:text-n-0 text-2xl font-heading font-bold">
    {{ t('login.pin-label') }}
  </h2>
  <pin-pad
    class="flex-1 max-h-[20rem] mb-4 !items-start"
    :wrong-value="badCredentials"
    @complete="pinEntered"
  />
  <div v-if="customError" class="text-r-dark dark:text-r-400">{{ customError }}</div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

import PinPad from '@/components/PinPad.vue'
import { useAuthStore } from '@/store/auth'
import { useConfigStore } from '@/store/config'
import sync from '@/sync/service'

defineEmits<{
  disablePin: []
}>()

const { t } = useI18n()
const router = useRouter()
const authStore = useAuthStore()
const configStore = useConfigStore()

const pin = ref<string>('')
const badCredentials = ref<boolean>(false)
const customError = ref<string>()

const isComplete = computed(() => pin.value.length === 4)

watch(pin, () => {
  if (isComplete.value) {
    startLogin()
  }
})

async function startLogin() {
  if (!isComplete.value) return
  try {
    await authStore.login({
      pin: pin.value
    })
    sync.resync()
    await configStore.refreshConfig()
    router.push({ name: 'board' })
  } catch (error: any) {
    const res = await error.response?.json()
    if (res?.code === 'INVALID_DEVICE') {
      customError.value = t('login.invalid-device')
    } else {
      badCredentials.value = true
      customError.value = undefined
    }
  }
}

function pinEntered(input: string) {
  pin.value = input
}
</script>
